$(function(){

  /*lightbox profile page*/
  var fancybox =  $(".hidden_click").fancybox({
    padding:0,
    closeBtn:false
  }).trigger('click');
  var fancybox =  $(".hidden_click").fancybox({
    padding:0,
    closeBtn:false
  }).trigger('click');
  $(".lightbox_content .navigate li a").fancybox({
    padding:0,
    closeBtn:false
  })
  /*end lightbox profile page*/


  $("a.lightbox").fancybox({
    padding:0,
    closeBtn:true,
    scrolling: 'no'
  })

  ////// GENERAL DYNAMIC STYLES

  // sets the "filled" class on a text input (or similar) which has a value;
  // removes it if not
  function setFilledClassOrNot(eventOrElement) {
    var element;
    if (eventOrElement.target) {
      element = eventOrElement.target;
    } else {
      element = eventOrElement;
    }

    if (element.value) {
      $(element).addClass('filled')
    } else {
      $(element).removeClass('filled')
    }
  }

  $(document).ready(function () {
    $('input[type=text], input[type=email], input[type=password], input[type=tel], textarea').each(function () {
      setFilledClassOrNot(this)
    }).keyup(setFilledClassOrNot).change(setFilledClassOrNot).blur(setFilledClassOrNot)

    $('div.gift_box').each(function () {
      var box_link = $(this).find('a')[0];
      var view_link = $(this).parent().find('.gift_box_link a.view')[0]

      var delegate = box_link || view_link;

      if (delegate) {
        $(this).css('cursor', 'pointer').click(function () {
          window.location = delegate.href;
        });
      }
    });
  });

  ////// GENERAL SHOPIFY INTEGRATION

  function addToShopifyCart(evt) {
    var variant_id = $(evt.target).closest('a').data('shopify-variant-id');
    $.ajax('/cart/add.js', {
      type: 'POST',
      data: { id: variant_id, quantity: 1 },
      dataType: 'text' // b/c don't care
    }).done(function () {
      window.location = '/cart';
    })
    return false;
  }

  $(document).ready(function () {
    $('a.add_to_cart').click(addToShopifyCart);
    $('.please_log_in a').click(promptForLoginIfNotLoggedIn);
  })

  ////// IFRAME DETECTION

  if (window.self !== window.top) {
    $('body').addClass('iframe')
  } else {
    $('body').addClass('root')
  }

  ////// LOGIN / SIGNUP

  var LOGIN_IFRAME_PERMITTED_PATHS = [
    '/account/login', '/account/register'
  ];

  // If login/register is completed in an iframe on top of a page whose pathname
  // matches this regexp, the page will be refreshed. Otherwise, the page which
  // completes the login/register process will be loaded into the parent frame.
  var LOGIN_IFRAME_REFRESH_PARENTS = /find-the-perfect-gift|gift-box/;

  $(document).ready(function() {
    $('a.account.not-logged-in').fancybox({
      padding: 0,
      closeBtn: false,
      scrolling: 'no',
      helpers: { 'title': null },
      beforeShow: function () {
        $('iframe.fancybox-iframe').load(function (e) {
          var iframeWindow = e.target.contentWindow;
          var newLocation = iframeWindow.location;

          var iframeHasErrors = $('.errors', iframeWindow.document).length > 0

          if (iframeHasErrors || LOGIN_IFRAME_PERMITTED_PATHS.indexOf(newLocation.pathname) >= 0) {
            // do nothing
            return false;
          } else if (LOGIN_IFRAME_REFRESH_PARENTS.test(window.top.location.pathname)) {
            // not using window.location.reload in order to force a GET
            var loc = window.top.location;
            var search = loc.search;
            var customerId = $('body', iframeWindow.document).data('customer');
            if (customerId) {
              if (search.length == 0) {
                search = "?customer_id=" + customerId;
              } else {
                search = search + "&customer_id=" + customerId;
              }
            }

            window.top.location = loc.protocol + '//' + loc.host + loc.pathname + search;
          } else {
            window.top.location.href = newLocation.href;
          }
        });
      }
    });
  });

  function promptForLoginIfNotLoggedIn() {
    var loginLink = $('a.account.not-logged-in');
    if (loginLink.length > 0) {
      loginLink.click();
      return false;
    } else {
      return true;
    }
  }

  ////// FIND-A-GIFT

  //// START

  function applyStartCustomSelect(bodyClass, doc) {
    // Selenium and customSelect don't work together
    if (!/capybara/i.test(navigator.userAgent)) {
      // font size is taken from surroundings by customSelect. have to override
      // after customSelect's styles are set in order to shrink it.
      $('body.' + bodyClass + ' .send_info select', doc).customSelect().css('font-size', '65%');
    }
  }

  $(document).ready(function() {
    // setup customSelect for not-an-iframe case
    applyStartCustomSelect('root', document);

    $('a.find-a-gift').fancybox({
      type: 'iframe',
      padding: 0,
      closeBtn: false,
      scrolling: 'no',
      helpers: { 'title': null },
      afterShow: function () {
        // setup customSelect for iframe case has to be deferred because
        // customSelect relies on absolutely positioning the select boxes
        // relative to the final rendered positions of the the other elements.
        var iframeDoc = $('iframe.fancybox-iframe')[0].contentWindow.document
        applyStartCustomSelect('iframe', iframeDoc);
      }
    })
  });

  //// PROFILE

  $(document).ready(function() {
    profileMarkSelectedActive($('.answer_list input[type=radio]:checked').first());

    // resize "selected" box for each answer img to match image dimensions
    $('.answer_list img').each(function (i, img) {
      updateProfileImageOverlayDimensions(img)
    }).load(function (e) {
      var img = e.target;
      updateProfileImageOverlayDimensions(img)
    });

    $('.answer_list img').click(function (e) {
      $(e.target).siblings('input[type=radio]').click();
    });

    $('.answer_list input[type=radio]').change(function (e) {
      profileMarkSelectedActive(e.target);
    });
  });

  function updateProfileImageOverlayDimensions(img) {
    $(img).siblings('span.ico_active').
      css('width', img.width).css('height', img.height)
  }

  function profileMarkSelectedActive(inputRadio) {
    if (inputRadio) {
      $('.answer_list li').removeClass('active');
      $(inputRadio).parents('.answer_list li').addClass('active');
    }
  }

  //// RECOMMENDATIONS

  $(document).ready(function () {
    $('.content.recommendations li div.add_list').click(updateRecommendedFavorite)
    $('.content.recommendations.no_shopper input.btn_next').click(promptForLoginIfNotLoggedIn)

    $('.content.recommendations .please_log_in a').click();
    $('.product_block .image img').load(updateRecommendationOverlayDimensions)

    $('.js-category-selector').change(filterRecommendations);
    $('.js-price-selector').change(filterRecommendations);
    $('#view_more').click(showMoreRecommendations)
  });

  function updateRecommendedFavorite(e) {
    var link = $(e.target).closest('.add_list');
    var container = $(link).parents('li').first()
    var isFavoriteNow = $(container).hasClass('favorite');
    var isFavoriteOnSuccess = !isFavoriteNow;
    var resourceUrl = $(link).data('resource');

    $(container).addClass('updating');

    $.ajax(resourceUrl, {
      type: 'PUT',
      contentType: 'application/json',
      data: JSON.stringify({ 'favorited': isFavoriteOnSuccess })
    }).done(function () {
      if (isFavoriteOnSuccess) {
        $(container).addClass('favorite')
      } else {
        $(container).removeClass('favorite')
      }
    }).complete(function () {
      $(container).removeClass('updating');
    });

    return false;
  }

  function updateRecommendationOverlayDimensions(e) {
    var img = e.target;
    $(img).siblings('span.overlay').css('height', $(img).height())
  }

  function filterRecommendations(e) {
      // save the number of currently shown items
      var currently_shown = $('.recommendations').data('num-shown');
      currently_shown = (currently_shown == undefined || currently_shown < 9) ? 9 : currently_shown;
      $('.recommendations').data('num-shown',currently_shown);

      $('li.recommendation').hide()
      // show selected categories
      var categories = $('.js-category-selector:checked').map(function(i,o){return '.js-cat-'+o.value}).toArray();
      var price_match = $('.js-price-selector:checked').map(function(i,o){return '.js-price-'+o.value}).toArray();

      if(categories.length+price_match.length > 0){
          $('li.recommendation').hide()
          if(categories.length>0){
            $(categories.join(', ')).addClass('matching');
            if(price_match.length>0){
                $('.matching:not('+price_match.join(',')+')').removeClass('matching');
            }
          }else{
            $(price_match.join(',')).addClass('matching');
          }

          $('.matching').slice(0,currently_shown).show()

          if($('.recommendation.matching:not(:visible)').length > 0 && $('.recommendation.matching:visible').length < 18){
              $('#view_more').removeAttr('disabled')
          }else{
              $('#view_more').attr('disabled', '')
          }
          $('.matching').removeClass('matching')
      }else{
        $('li.recommendation').slice(0,currently_shown).show()
        if($('.recommendation:not(:visible)').length > 0 && $('.recommendation:visible').length < 18){
            $('#view_more').removeAttr('disabled')
        }else{
            $('#view_more').attr('disabled', '')
        }
      }

  }

  function showMoreRecommendations(e) {
      var currently_shown = $('.recommendations').data('num-shown');
      currently_shown = currently_shown || 9;
      if(currently_shown <= 15) currently_shown += 3;
      $('.recommendations').data('num-shown',currently_shown);
      filterRecommendations(null);
      return false;
  }

  //// FAVORITES / REQUEST ADVICE

  function deleteAdvisorRow(evt) {
    $(evt.target).closest('li').remove();

    return false;
  }

  function addEmailAdvisorRow(evt) {
    var theList = $(evt.target).closest('.email_tab').children('ul').first();

    var lastI = theList.find('li input[type=text]').last()[0].name.match(/\d+/)[0];
    var i = parseInt(lastI) + 1;

    theList.append(
      '<li class="advisor clearfix">' +
      '<input type="text" placeholder="Name" name="advisors[' + i + '][name]" class="name">' +
      '<input type="text" placeholder="E-mail Address" name="advisors[' + i + '][email_address]" class="email">' +
      '<a class="delete" href="#">x</a>' +
      '</li>'
    );

    theList.children('li').last().find('input').
      keyup(setFilledClassOrNot).change(setFilledClassOrNot).blur(setFilledClassOrNot);

    return false;
  }

  $(document).ready(function () {
    $('li.advisor .delete').click(deleteAdvisorRow)
    $('.fav_votes .email_tab #add_advisor').click(addEmailAdvisorRow)
  });

  //// PROVIDE ADVICE

  function displayVoteScore(voteRatings, score) {
    voteRatings.find('a').each(function () {
      if ($(this).data('score') <= score) {
        $(this).addClass('active');
      } else {
        $(this).removeClass('active');
      }
    });
  }

  function updateSelectedVoteScore(evt) {
    var targetScore = $(evt.target).data('score');
    var container = $(evt.target).closest('.vote_ratings');
    container.find('input[type="hidden"]').val(targetScore);
    displayVoteScore(container, targetScore);
    return false;
  }

  function hoverVoteScore(evt) {
    console.log('hover', evt)
    var targetScore = $(evt.target).data('score');
    var container = $(evt.target).closest('.vote_ratings');
    displayVoteScore(container, targetScore);
  }

  function unhoverVoteScore(evt) {
    console.log('unhover', evt)
    var container = $(evt.target).closest('.vote_ratings');
    var targetScore = container.find('input[type="hidden"]').val();
    displayVoteScore(container, targetScore);
  }

  $(document).ready(function () {
    $('.vote_ratings a').click(updateSelectedVoteScore).
      mouseover(hoverVoteScore).mouseout(unhoverVoteScore)
  });
});
